// Fonte única das faixas de frete por CEP e do frete fixo de latas/petiscos.
// Espelha os Shipping Profiles reais do Shopify configurados em SPEC-015 (ver `specs/SPEC-015-frete-zonas-e-faixas.md` §8).
// Usado por shipping-calculator.js (carrinho) e shipping-consult.js (PDP) — não duplicar esta tabela.
(function (global) {
  const PRODUCT_TYPES = {
    FLAT: 'Latas e Petiscos',
    RESTRICTED: 'Dietas e Congelados',
  };

  const FLAT_RATE = {
    price: 25.0,
    days: '5 a 8 dias úteis',
  };

  // Cada cidade aponta pra um tier (preço/prazo). Ranges de CEP herdados da whitelist
  // anterior do tema + as 3 cidades novas do PDF sem CEP hardcoded antes (Cotia, Sorocaba, Itu).
  const CEP_TIERS = [
    {
      name: 'Ribeirão Preto',
      price: 19.9,
      days: '5 dias úteis',
      cities: {
        'Ribeirão Preto': [['14000-001', '14109-999']],
      },
    },
    {
      name: 'Faixa 1',
      price: 19.9,
      days: '10 dias úteis',
      cities: {
        Campinas: [['13000-001', '13139-999']],
      },
    },
    {
      name: 'Faixa 2',
      price: 29.9,
      days: '10 dias úteis',
      cities: {
        'São Carlos': [['13560-001', '13569-999']],
        'Nova Odessa': [['13380-001', '13389-999']],
        Franca: [['14400-001', '14419-999']],
        Sumaré: [['13170-001', '13182-999']],
        'Santa Bárbara do Oeste': [['13450-001', '13464-999']],
        Hortolândia: [['13183-001', '13189-999']],
        Cravinhos: [['14140-000', '14149-999']],
        Mococa: [['13770-001', '13779-999']],
        Sertãozinho: [['14160-001', '14179-999']],
        Americana: [['13465-001', '13479-999']],
        Paulínia: [['13140-001', '13149-999']],
        Araraquara: [['14800-001', '14819-999']],
        Batatais: [['14300-001', '14309-999']],
        'Américo Brasiliense': [['14820-000', '14829-999']],
        Araras: [['13600-001', '13619-999']],
        Barretos: [['14780-001', '14789-999']],
        Barrinha: [['14860-000', '14869-999']],
        Bebedouro: [['14700-001', '14719-999']],
        Brodowski: [['14340-001', '14349-999']],
        Cajuru: [['14240-000', '14249-999']],
        'Casa Branca': [['13700-001', '13709-999']],
        Colina: [['14770-000', '14779-999']],
        'Cristais Paulista': [['14460-000', '14469-999']],
        Descalvado: [['13690-001', '13699-999']],
        Dobrada: [['15980-000', '15989-999']],
        Dumont: [['14120-000', '14129-999']],
        Guará: [['14580-000', '14589-999']],
        Guariba: [['14840-001', '14849-999']],
        Guatapará: [['14115-000', '14119-999']],
        Ibaté: [['14815-000', '14819-999']],
        Ipuã: [['14610-000', '14619-999']],
        Itirapuã: [['14420-000', '14429-999']],
        Ituverava: [['14500-001', '14509-999']],
        Jaborandi: [['14780-000', '14789-999']],
        Jaboticabal: [['14870-001', '14879-999']],
        Jardinópolis: [['14680-001', '14689-999']],
        Jaguariúna: [['13910-001', '13919-999']],
        Leme: [['13610-001', '13619-999']],
        'Luís Antônio': [['14210-000', '14219-999']],
        Matão: [['15990-001', '15999-999']],
        'Monte Alto': [['15910-001', '15919-999']],
        'Monte Azul Paulista': [['14730-000', '14739-999']],
        'Morro Agudo': [['14640-000', '14649-999']],
        Nuporanga: [['14670-000', '14679-999']],
        Orlândia: [['14620-001', '14629-999']],
        'Patrocínio Paulista': [['14415-000', '14419-999']],
        Pirassununga: [['13630-001', '13639-999']],
        Pitangueiras: [['14750-001', '14759-999']],
        Pontal: [['14180-000', '14189-999']],
        'Porto Ferreira': [['13660-001', '13669-999']],
        Pradópolis: [['14850-000', '14859-999']],
        Rincão: [['14830-000', '14839-999']],
        'Rio Claro': [['13500-001', '13509-999']],
        'Sales Oliveira': [['14660-000', '14669-999']],
        'Santa Cruz da Conceição': [['13625-000', '13629-999']],
        'Santa Cruz da Esperança': [['14250-000', '14259-999']],
        'Santa Cruz das Palmeiras': [['13650-001', '13659-999']],
        'Santa Ernestina': [['15970-000', '15979-999']],
        'Santa Lúcia': [['14825-000', '14829-999']],
        'Santa Rita do Passa Quatro': [['13670-001', '13679-999']],
        'Santa Rosa de Viterbo': [['14270-000', '14279-999']],
        'Santo Antônio da Alegria': [['14390-000', '14399-999']],
        'São Joaquim da Barra': [['14600-001', '14609-999']],
        'São José do Rio Pardo': [['13720-001', '13729-999']],
        'São Simão': [['14200-000', '14209-999']],
        'Serra Azul': [['14230-000', '14239-999']],
        Serrana: [['14150-001', '14159-999']],
        Tabatinga: [['14910-000', '14919-999']],
        Taiúva: [['14725-000', '14729-999']],
        Tambaú: [['13710-000', '13719-999']],
        Tapiratiba: [['13760-000', '13769-999']],
        Taquaral: [['14765-000', '14769-999']],
        Taquaritinga: [['15900-001', '15909-999']],
        'Terra Roxa': [['14745-000', '14749-999']],
        Viradouro: [['14740-000', '14744-999']],
        'Vista Alegre do Alto': [['15920-000', '15929-999']],
      },
    },
    {
      name: 'Faixa 3',
      price: 39.9,
      days: '10 dias úteis',
      cities: {
        'São Paulo Capital': [
          ['01000-000', '05999-999'],
          ['08000-000', '08499-999'],
        ],
        Cotia: [['06700-001', '06729-999']],
        Indaiatuba: [['13330-001', '13349-999']],
        Jundiaí: [['13200-001', '13219-999']],
        Vinhedo: [['13280-001', '13289-999']],
        Valinhos: [['13270-001', '13279-999']],
        Louveira: [['13290-001', '13294-999']],
        Sorocaba: [['18000-001', '18109-999']],
        Itu: [['13300-001', '13314-999']],
      },
    },
  ];

  function formatCep(rawCep) {
    return String(rawCep || '')
      .replace(/\D/g, '')
      .replace(/(\d{5})(\d{3})/, '$1-$2');
  }

  function isCompleteCep(cep) {
    return /^\d{5}-\d{3}$/.test(cep);
  }

  function formatMoney(value) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value);
  }

  function findCepTier(rawCep) {
    const cep = formatCep(rawCep);
    for (const tier of CEP_TIERS) {
      for (const city in tier.cities) {
        const ranges = tier.cities[city];
        if (ranges.some(([start, end]) => cep >= start && cep <= end)) {
          return { city, tierName: tier.name, price: tier.price, days: tier.days };
        }
      }
    }
    return null;
  }

  global.PapaPetsShipping = {
    PRODUCT_TYPES,
    FLAT_RATE,
    formatCep,
    isCompleteCep,
    formatMoney,
    findCepTier,
  };
})(window);
